module.exports = __webpack_public_path__ + "static/media/机组_03.67ae134e.png";